import { IRoad } from '../types/geo';
import { CommuteButtonStatus, ICommuteSuggest } from '../store/commute_popup';
import { IRoads } from '../store/roads';

export const isCommuteEnabled = (commuteData: { [key: number]: number }, commuteDistance: number) => (id: number) => {
  const distance = commuteData[id];

  return !!distance && distance <= commuteDistance;
};

export const getCommuteButtonStatus = (
  commuteData: { [key: number]: number },
  commuteDistance: number,
  ids: number[] = [],
): CommuteButtonStatus => {
  const isSelectedDisabled = !!ids.length && !ids.some(isCommuteEnabled(commuteData, commuteDistance));
  const isButtonDisabled = !ids.length || isSelectedDisabled;

  return Number(isSelectedDisabled) + Number(isButtonDisabled);
};

export const filterSelectedCommute = (ids: number[]) => (value: { id: number }) => ids.includes(value.id);

export const getRoadsModels = (roads: IRoads): IRoad[] => {
  const { currentRoads, selectedRoads } = roads;

  return currentRoads.filter(filterSelectedCommute(selectedRoads));
};

export const commuteSuggestSort = (a: ICommuteSuggest, b: ICommuteSuggest) =>
  // Сортировка по порядку, сначала isEnabled, затем isActive
  Number(a.isActive) * 0.5 + Number(b.isEnabled) - (Number(b.isActive) * 0.5 + Number(a.isEnabled));

interface IWithIds {
  id: number;
}

export const commuteSuggestUpdater =
  (commuteData: { [key: number]: number }, selected: number[], distance: number) =>
  <T extends IWithIds>(suggest: T): T =>
    Object.assign(suggest, {
      isActive: selected.includes(suggest.id),
      isEnabled: !!commuteData[suggest.id] && commuteData[suggest.id] <= distance,
    }) as T;
